import React from 'react';
import { connect } from 'react-redux';
import { cardElementChange } from '../reducer';
import get from 'lodash.get';

class BankAccountView extends React.Component {
    componentDidMount() {
        const style = {
            base: { fontFamily: this.props.fontName, lineHeight: "1.21428571em", fontSize: "16px" }
        };

        const options = {
            style: style,
            disabled: false,
            hideIcon: false,
            iconStyle: "default"
        };

        // Create an instance of the auBankAccount Element.
        const auBankAccount = this.props.stripe && this.props.stripe.elements().create('auBankAccount', options);
        auBankAccount.on("change", this.onCardChange);

        const form = document.getElementById("payment-form");
        form.addEventListener("submit", this.props.handleSubmit.bind(this, auBankAccount));

        // Add an instance of the auBankAccount Element into
        // the `au-bank-account-element` <div>.
        auBankAccount.mount('#au-bank-account-element');
    }

    onCardChange = card => {
        this.props.onCardChange(card);
    }

    render() {
        return (
            <div className="required field">
                {
                    this.props.showHeader &&
                    <label className="card-header">Bank account details</label>
                }
                <div id="au-bank-account-element" />
                {
                    this.props.errorMessage &&
                    <p className="c-error">{this.props.errorMessage}</p>
                }
            </div>
        );
    }
}

const mapState = state => {
    const fontName = get(state, "customization.stripeCardElementFontName") ? get(state, "customization.stripeCardElementFontName") : "Lato";
    return {
        errorMessage: state.donation.cardErrorMessage,
        fontName
    };
};

const mapDispatch = dispatch => {
    return {
        onCardChange: (card) => {
            dispatch(cardElementChange(card));
        },
    };
};

const BankAccount = connect(mapState, mapDispatch)(BankAccountView);
export default BankAccount;